<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import DevToolsTrigger from './components/DevToolsTrigger.vue';
import DevToolsModal from './components/DevToolsModal.vue';
import MockParticipantList from './components/MockParticipantList.vue';

const isOpen = ref(false);
function handleKeydown(e: KeyboardEvent) {
    // Cmd + I to toggle dev tools
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'i') {
        isOpen.value = !isOpen.value;
    }
}

onMounted(() => {
    window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
    window.removeEventListener('keydown', handleKeydown);
});
</script>

<template>
    <div data-slot="pokerly-dev-tools relative">
        <DevToolsTrigger v-if="!isOpen" @click="isOpen = true" />
        <DevToolsModal :open="isOpen" @close="isOpen = false">
            <MockParticipantList />
        </DevToolsModal>
    </div>
</template>
